import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import HeadingLayout from "src/components/base/heading-layout";
import { Text } from "src/components/base/text";

/**
 * The properties for {@link TailscaleAccessExpired}
 */
export type TailscaleAccessExpiredProps = {};

/**
 * The error page for tailscale user authentication
 */
export default function TailscaleAccessExpired(props: TailscaleAccessExpiredProps) {
    const [t] = useTranslation("user-tailscale");

    return (
        <HeadingLayout heading={t("heading.access-expired")}>
            <Text>{t("description.access-expired")}</Text>
        </HeadingLayout>
    );
}

export const Route = createFileRoute("/_user/u/tailscale-login/access-expired")({
    component: TailscaleAccessExpired,
});
